import { DefaultResponseWithData } from "./system";

/** Must stay numerically identical to VehicleComplexity in the API and in Betty. */
export enum VehicleComplexity {
  Unranked = 0,
  Easy = 1,
  Medium = 2,
  Hard = 3,
}

export const COMPLEXITY_LABELS: Record<VehicleComplexity, string> = {
  [VehicleComplexity.Unranked]: "Unranked",
  [VehicleComplexity.Easy]: "Easy",
  [VehicleComplexity.Medium]: "Medium",
  [VehicleComplexity.Hard]: "Hard",
};

/** Bay capacity is planned per band, so the bands get the colours the planner already uses. */
export const COMPLEXITY_CLASSES: Record<VehicleComplexity, string> = {
  [VehicleComplexity.Unranked]: "bg-gray-100 text-gray-600 border-gray-200",
  [VehicleComplexity.Easy]: "bg-emerald-50 text-emerald-700 border-emerald-200",
  [VehicleComplexity.Medium]: "bg-amber-50 text-amber-700 border-amber-200",
  [VehicleComplexity.Hard]: "bg-red-50 text-red-700 border-red-200",
};

export interface IVehicleComplexityRule {
  id: string;
  customerId: string;
  customerName: string | null;
  /** Null means "any make" — the rule applies to every make. */
  make: string | null;
  /** Null means "any model". */
  model: string | null;
  complexity: VehicleComplexity;
  notes: string | null;
  created: string;
  updated: string | null;
  /** How many fields the rule constrains. Higher wins when two rules both match a vehicle. */
  specificity: number;
  /** Resolved by the API: whether this site owns the row and may change it. */
  canEdit: boolean;
}

export interface ICreateUpdateVehicleComplexityRuleRequest {
  make: string | null;
  model: string | null;
  complexity: VehicleComplexity;
  notes: string | null;
}

export interface IVehicleComplexityMatchRequest {
  make: string | null;
  model: string | null;
}

export interface IVehicleComplexityMatch {
  /** Null when no rule covered the vehicle — not the same as Unranked. */
  complexity: VehicleComplexity | null;
  matchedRuleId: string | null;
  matchedMake: string | null;
  matchedModel: string | null;
}

export interface IVehicleComplexityRulesResponse
  extends DefaultResponseWithData<IVehicleComplexityRule[]> {}
export interface ISingleVehicleComplexityRuleResponse
  extends DefaultResponseWithData<IVehicleComplexityRule> {}
export interface IVehicleComplexityMatchResponse
  extends DefaultResponseWithData<IVehicleComplexityMatch> {}
